import * as angular from 'angular';

"use strict";
angular.module('scanStationCtrl', []);

export default 'scanStationCtrl'
